import { useMemo } from "react";
import { Stack } from "@mui/material";
import { BarChart, LocationOn } from "@mui/icons-material";
import { StatCard } from "../../../../../../../components/Common";
import {
  useGetAllNetworkStatsQuery,
  useGetAllNetworkLocationStatsQuery,
} from "../../../../../../../store/allNetworkStats";
import {
  parseNetworkLocationData,
  parseNetworkLocationSharesData,
} from "./parseNetworkLocationData";
import { nFormatter, Text } from "@asayinc/component-library";

const NetworkStats = () => {
  // get network stat data
  const { data: stats, isFetching } = useGetAllNetworkStatsQuery();

  // get network location data
  const { data: locationData, isFetching: isLocationFetching } =
    useGetAllNetworkLocationStatsQuery();

  // parse location data for the customer location card
  const locationStats = useMemo(
    () => parseNetworkLocationData(locationData),
    [locationData]
  );

  // parse location data for the shares location card
  const locationSharesStats = useMemo(
    () => parseNetworkLocationSharesData(locationData),
    [locationData]
  );

  // parse all network stats for the combined stats card
  const networkStats = useMemo(() => {
    if (stats) {
      return [
        {
          title: "Total Customers",
          value:
            stats.totalCustomers !== undefined
              ? nFormatter(stats.totalCustomers)
              : undefined,
        },
        {
          title: "Total Shares",
          value:
            stats.totalShares !== undefined
              ? nFormatter(parseFloat(stats.totalShares))
              : undefined,
        },
        {
          title: "Average Shares",
          value:
            stats.averageShares !== undefined
              ? nFormatter(stats.averageShares)
              : undefined,
        },
      ];
    }
    return [];
  }, [stats]);

  const allApisLoading = isFetching && isLocationFetching;

  return (
    <Stack>
      <Text variant="subtitle1" width={allApisLoading ? "320px" : undefined}>
        {allApisLoading ? undefined : "Overview"}
      </Text>
      <Stack direction="row" gap={6} pt={6} pb={12} overflow="auto">
        <StatCard
          icon={<BarChart />}
          isLoading={isFetching}
          title="Network Stats"
          minWidth="220px"
          width="0"
          sx={{ flex: "1 1 0px" }}
          multiStats={networkStats}
        />
        <StatCard
          icon={<LocationOn />}
          title="Top Location Shareholders"
          width="0"
          minWidth="220px"
          sx={{ flex: "1 1 0px" }}
          isLoading={isLocationFetching}
          multiStats={locationStats}
        />
        <StatCard
          icon={<LocationOn />}
          title="Top Location Total Shares"
          width="0"
          minWidth="220px"
          sx={{ flex: "1 1 0px" }}
          isLoading={isLocationFetching}
          multiStats={locationSharesStats}
        />
      </Stack>
    </Stack>
  );
};

export default NetworkStats;
